"use client";

import { useUmamiAnalytics } from "@analytics";
import { useLocalePathname } from "@i18n/routing";
import { EffectCard } from "@saas/shared/components/EffectCard";
import {
	type EffectKind,
	WORKBENCH_TEMPLATES,
} from "@saas/shared/config/effects-catalog";
import { cn } from "@ui/lib";

/** 工作台右栏 Templates tab 的内容：4:3 整齐网格，同特效页右栏；点卡片进对应特效 / 工具页 */
export function WorkbenchTemplates({
	kind,
	className,
}: {
	kind: EffectKind;
	/** 滚动区左右留白，跟着各工作台 tab 栏的边距走 */
	className?: string;
}) {
	const { trackEvent } = useUmamiAnalytics();
	const pathname = useLocalePathname();

	return (
		<div className={cn("flex-1 overflow-y-auto pb-6", className)}>
			<div className="mx-auto grid max-w-5xl grid-cols-2 gap-3 lg:grid-cols-3 2xl:grid-cols-4">
				{WORKBENCH_TEMPLATES[kind].map((item) => (
					<EffectCard
						key={item.href}
						item={item}
						uniform
						sizes="(max-width: 640px) 50vw, 240px"
						onClick={() =>
							void trackEvent("workbench-template-clicked", {
								from: pathname,
								to: item.href,
							})
						}
					/>
				))}
			</div>
		</div>
	);
}
